import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SideNavigationOverlay from 'components/Credit24/SelfService/Navigation/SideNavigationOverlay';

const propTypes = {
  location: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired,
};

class SideNavigation extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
    };
    this.toggleMenuVisibility = this.toggleMenuVisibility.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { pathname } = this.props.location;
    if (pathname !== nextProps.location.pathname && this.state.isOpen) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.setState({
      isOpen: false,
    });
  }

  toggleMenuVisibility() {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    if (!this.props.authentication.isAuthenticated) {
      return null;
    }

    return (
      <nav className="mobile-nav">
        <button className="mobile-nav__btn" type="button" onClick={this.toggleMenuVisibility}>
          <FormattedMessage id="navigation.menu" />
        </button>
        <SideNavigationOverlay
          {...this.props}
          isOpen={this.state.isOpen}
          closeHandler={this.closeMenu}
        />
      </nav>
    );
  }
}

SideNavigation.propTypes = propTypes;

export default SideNavigation;
